/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CalendarEntry } from './CalendarEntry';
import {
    CalendarEntryFromJSON,
    CalendarEntryFromJSONTyped,
    CalendarEntryToJSON,
} from './CalendarEntry';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableCalendarEntries
 */
export interface PageableCalendarEntries {
    /**
     * 
     * @type {Array<CalendarEntry>}
     * @memberof PageableCalendarEntries
     */
    result: Array<CalendarEntry>;
    /**
     * 
     * @type {Page}
     * @memberof PageableCalendarEntries
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableCalendarEntries interface.
 */
export function instanceOfPageableCalendarEntries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableCalendarEntriesFromJSON(json: any): PageableCalendarEntries {
    return PageableCalendarEntriesFromJSONTyped(json, false);
}

export function PageableCalendarEntriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableCalendarEntries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(CalendarEntryFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableCalendarEntriesToJSON(value?: PageableCalendarEntries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(CalendarEntryToJSON)),
        'page': PageToJSON(value.page),
    };
}

